"use client";

import { useEffect } from "react";

export function useEruda() {
  useEffect(() => {
    if (typeof window === "undefined") return;
    const isOffline = process.env.NEXT_PUBLIC_REACT_APP_DOMAIN === "offline";
    const alreadyExists = document.getElementById("eruda");
    if (isOffline && !alreadyExists) {
      import("eruda").then((eruda) => {
        eruda.default.init();
      });
    }
  }, []);
}
